'use strict';

var BookingsIntakeAggregationFactory = function BookingsIntakeAggregationFactory(DataAggregationFactory, bookingsIntakeTransformationService) {
  function BookingsIntakeAggregation() {
    DataAggregationFactory.call(this, ['cabin', 'class', 'segment-classes', 'market', 'market-product-group', 'service'], ['cabin-flight-analysis', 'class-flight-analysis', 'segment-flight-analysis', 'market-demand-analysis', 'market-product-group-analysis', 'service-demand-analysis', 'service-flight-analysis']);
  }
  BookingsIntakeAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  BookingsIntakeAggregation.constructor = BookingsIntakeAggregation;
  BookingsIntakeAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType.indexOf(targetType) > -1 && this.sourceType.indexOf(sourceType) > -1;
  };
  BookingsIntakeAggregation.prototype.aggregate = function (allData) {
    return bookingsIntakeTransformationService.createBookingsIntakeHtml(allData);
  };
  return BookingsIntakeAggregation;
};
BookingsIntakeAggregationFactory.$inject = ['DataAggregationFactory', 'BookingsIntakeTransformationService'];
module.exports = BookingsIntakeAggregationFactory;